module.exports = __webpack_public_path__ + "static/img/jcsj@2x.0b98f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jcsj@2x.png
// module id = DQ6g
// module chunks = 2